// Thin wrapper around the Microsoft Clarity global (loaded in public/index.html).
//
// The Clarity tag is only injected on the production domain (see the hostname
// guard in index.html), so `window.clarity` is undefined on localhost and on
// Netlify deploy previews. Every function here no-ops safely in that case, so
// callers never need to check whether Clarity is present.

function clarity(...args) {
  if (typeof window === 'undefined') return;
  const c = window.clarity;
  if (typeof c !== 'function') return; // not loaded (dev / preview / blocked)
  try {
    c(...args);
  } catch {
    /* never let analytics break the app */
  }
}

/**
 * Tie the current Clarity session to a signed-in user so their recordings are
 * searchable by email, and tag the session with plan / audience for filtering.
 */
export function identifyUser(user) {
  if (!user) return;
  const email = user.email || undefined;
  if (email) {
    // custom-id, custom-session-id (let Clarity pick), custom-page-id, friendly-name
    clarity('identify', email, undefined, undefined, email);
  }

  const meta = user.user_metadata || {};
  if (meta.plan) clarity('set', 'plan', String(meta.plan));
  clarity('set', 'audience', meta.founding_member ? 'founding' : 'public');
  clarity('set', 'auth', 'signed-in');
}

/** Custom event - e.g. trackEvent('registration_started'). */
export function trackEvent(name) {
  if (name) clarity('event', name);
}

/** Set an arbitrary session tag - e.g. tag('page', 'founding'). */
export function tag(key, value) {
  if (key && value != null) clarity('set', key, String(value));
}
